module.exports = __webpack_public_path__ + "static/media/close.d8e237c1.svg";